var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountActivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#62C776"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1476_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3418 7.96984H14.6313C14.7407 7.61759 14.7017 7.12601 15.1242 7.03795C16.3113 7.09766 17.6011 6.93481 18.777 7.03011C19.2765 7.07052 19.2492 7.55365 19.3418 7.96984Z",
    fill: "#62C776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 20V9.23593C13.9995 9.08936 14.2641 8.86921 14.4075 8.88006L19.5667 8.87886C19.7196 8.84689 19.9998 9.11892 19.9998 9.26368V19.9572C19.9998 19.9602 19.963 20 19.9602 20H13.9995ZM16.5523 10.7571H15.7101V12.5775H16.5523V10.7571ZM18.2629 10.7571H17.4207V12.5775H18.2629V10.7571ZM16.5523 13.9991H15.7101V15.8195H16.5523V13.9991ZM18.2629 13.9991H17.4207V15.8195H18.2629V13.9991Z",
    fill: "#62C776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1575 12.5775V14.4117C13.1575 14.4147 13.1207 14.4545 13.1179 14.4545H9.73685V15.3647H13.1581V16.758H9.73685V17.6682H13.1581V19.9578C13.1581 19.9608 13.1213 20.0006 13.1185 20.0006H8V13.3887C8 13.0672 8.45263 12.5781 8.7501 12.5781H13.1581L13.1575 12.5775Z",
    fill: "#62C776"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1476_1696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountActivo);
export default __webpack_public_path__ + "static/media/countActivo.272b6ce9ba3690619f446b550f804ac6.svg";
export { ForwardRef as ReactComponent };